/* gd-segundo.js — «o 2.º maillot já com preço» (dono 13-10-2026). Regras e textos em snippets/gd-segundo.liquid.

   ⚠️ DINHEIRO. O número de um cartão é QUANTO O TOTAL DO CARRINHO SOBE se o cliente juntar esse artigo:
   remise(carrinho + artigo) − remise(carrinho), com o modelo do pack do carrinho (`GdCarrinho.regras.melhor`:
   BxGy sem limite de usos, o mais barato leva o desconto, arredonda para baixo ao cêntimo, Duo e Trio não se
   somam). Medido a 13-10 num carrinho real: France 39,99 + Rétro 44,99 = 72,99 (o −30 % caiu na France).
   Só se mostra quando o mesmo modelo reproduz a remise que a Shopify deu ao carrinho ATUAL, em EUR e sem
   código; senão tudo volta ao preço normal. Na ficha, o preço, o botão e a barra fixa mostram o mesmo número que o cartão.
   Revisão adversarial 13-10 (corrigido): escrever só quando muda (o innerHTML relido traz &nbsp;/&amp; e fazia um
   ciclo a cada frame); linhas do pack fora de «tudo» (NBA: Duo e Trio com coleções diferentes) = sem promessa;
   carrinho mudado noutra aba ou edição do pack a começar/acabar = sem promessa; botão de versão esgotada intocado;
   fotos do par sem corridas. */
(() => {
  'use strict';
  if (window.__gdSegundo) return;
  window.__gdSegundo = true;
  const d = document;
  let T = {};
  let LIMITE = 0;   // epoch (s) em que o pack muda (uma edição começa ou acaba): daí em diante, sem promessa
  try { const cfg = JSON.parse(d.querySelector('[data-gd2-cfg]').textContent); T = cfg.t || {}; LIMITE = +cfg.limite || 0; } catch (_) { return; }
  let velho = false; // o carrinho mudou noutra aba e esta página ainda tem a fotografia antiga

  const regras = () => { const C = customElements.get('gd-carrinho'); return C && C.regras; };
  const fmt = (c) => (window.GdPrecos ? window.GdPrecos.fmt(c, { moeda: 'EUR' }) : `${(c / 100).toFixed(2).replace('.', ',')} €`);

  /* o carrinho que a gaveta desenhou (o mesmo JSON que o gd-carrinho.js lê) */
  function carrinho() {
    const el = d.querySelector('[data-gd-carrinho]');
    if (!el) return null;
    let D;
    try { D = JSON.parse(el.textContent); } catch (_) { return null; }
    /* as propriedades chegam do Liquid como pares [chave, valor] com HTML escapado: o carrinho converte-as
       com o seu `propsDe` antes de as contas — o mesmo aqui, senão o suplemento das opções dá 0 */
    const R = regras();
    if (R && typeof R.propsDe === 'function') (D.linhas || []).forEach((l) => { l.props = R.propsDe(l.props); });
    return D;
  }

  /* o estado que permite prometer: { R, us, pack, n, antes, total, orig } ou null.
     Sem opções pagas no carrinho (ou com a cobrança das opções desligada, em que o checkout é o normal), as
     contas são as da Shopify: o modelo tem de reproduzir a remise que a Shopify deu. Com opções pagas, só
     quando o carrinho chega a «exato» (`contas()`: a tabela de preços das opções está cá e a remise da draft
     foi conferida) — aí cada linha conta base + opções, como a draft cobra. Em espera, sem tabela ou
     aproximado: não se promete nada. */
  function estado() {
    const R = regras();
    const D = carrinho();
    if (!R || !D || !D.pack || D.moeda !== 'EUR' || (D.codigos || []).length) return null;
    if (velho || (LIMITE && Date.now() / 1000 >= LIMITE)) return null;
    const linhas = D.linhas || [];
    /* o modelo trata «elegível» como um conjunto só; os artigos NBA entram no Duo e no Trio por coleções
       diferentes — com um deles no carrinho, não se promete nada */
    if (linhas.some((l) => l.el && l.tu !== true)) return null;
    const C = typeof R.contas === 'function' ? R.contas(D) : null;
    if (!C) return null;
    let us;
    let antes;
    let total;
    let orig;
    if (C.estado === 'exato') {
      us = R.unidades(linhas, (l, i) => l.base + (C.sups[i] || 0));
      antes = C.desc;
      total = C.tot;
      orig = C.sub;
      if (R.melhor(us, D.pack).total !== antes) return null;
    } else if (C.estado === 'base' || C.estado === 'sem-cobranca') {
      us = R.unidades(linhas, (l) => l.base);
      antes = R.melhor(us, D.pack).total;
      const apps = D.apps || [];
      if (apps.length > 1) return null;
      if (apps.length === 1) {
        const a = apps[0];
        if (a.tipo !== 'automatic' || a.vt !== 'percentage' || a.tt !== 'line_item') return null;
        if (antes !== a.tot) return null;
      } else if (antes !== 0) return null;
      total = D.total;
      orig = linhas.reduce((s, l) => s + (l.orig || 0), 0);
    } else return null;
    const n = us.filter((u) => u.el).length;
    return { R, us, pack: D.pack, n, antes, total, orig };
  }

  /* quanto o total sobe ao juntar uma unidade elegível de `c` cêntimos (já com as opções dela, se tiver) */
  function sobe(E, c) {
    const us = E.us.concat([{ i: -1, p: c, el: true }]);
    const depois = E.R.melhor(us, E.pack).total;
    return c - (depois - E.antes);
  }

  /* escrever só quando o que se quer mudou ou alguém mexeu no nó: o innerHTML relido não é igual ao escrito
     (&nbsp; do preço, &amp; dos URLs), por isso guarda-se o que se escreveu e o que ficou */
  const escrito = new WeakMap();
  const poe = (el, html) => {
    if (!el) return;
    const m = escrito.get(el);
    if (m && m.quer === html && m.ficou === el.innerHTML) return;
    el.innerHTML = html;
    escrito.set(el, { quer: html, ficou: el.innerHTML });
  };

  /* ── cartões: <span class="price" data-gd2="cêntimos"> ── */
  function cartoes(E) {
    d.querySelectorAll('.price[data-gd2]').forEach((p) => {
      if (p.dataset.gd2Orig == null) p.dataset.gd2Orig = p.innerHTML;
      const c = parseInt(p.dataset.gd2, 10);
      const v = E && E.n > 0 && c > 0 ? sobe(E, c) : c;
      if (!E || !(v < c)) { if (p.dataset.gd2Mostra) { poe(p, p.dataset.gd2Orig); delete p.dataset.gd2Mostra; } return; }
      poe(p, `${fmt(v)}<s class="gd2-s">${fmt(c)}</s><span class="gd2-n">${T.nota}</span>`);
      p.dataset.gd2Mostra = '1';
    });
  }

  /* ── a faixa do pack (coleções, home): diz o que já está no carrinho ── */
  function faixas(E) {
    d.querySelectorAll('.packbar').forEach((b) => {
      if (b.dataset.gd2Orig == null) b.dataset.gd2Orig = b.innerHTML;
      if (E && E.n > 0) poe(b, `<span>${(E.n === 1 ? T.barra1 : T.barra).replace('%n%', E.n)}</span>`);
      else poe(b, b.dataset.gd2Orig);
    });
  }

  /* ── a ficha. Com o carrinho cheio quem chega aqui já percebeu a loja: mostra-se O PAR DELE — as camisolas do
     carrinho + esta, lado a lado, o total do conjunto e quanto poupa — e o preço grande é o que o total sobe
     (riscado o normal, a poupança em €). O botão e a barra fixa dizem o mesmo número, já com as opções
     escolhidas (a draft desconta sobre o preço com opções, por isso o candidato entra com `total()`).
     Carrinho vazio: a escada «2 pour X · 3 pour Y». Uma edição com data (2 + 1 offert até…) fica como está. ── */
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  /* as fotos do que está no carrinho (só os artigos do pack, até 2): um pedido por estado do carrinho */
  let fotos = { chave: '', p: null };
  function fotosCarrinho(chave) {
    if (fotos.chave === chave && fotos.p) return fotos.p;
    const p = fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((c) => {
        const D = carrinho() || {};
        const el = new Set((D.linhas || []).filter((l) => l.el).map((l) => l.k));
        const lista = [];
        (c.items || []).forEach((i) => { if (el.has(i.key)) for (let n = 0; n < i.quantity && lista.length < 2; n++) lista.push({ img: i.image, t: i.product_title }); });
        return lista;
      }).catch(() => { if (fotos.chave === chave) fotos = { chave: '', p: null }; return []; });
    fotos = { chave, p };
    return p;
  }
  /* família (13-10): numa ficha de adulto, a versão de criança (ou bebé) da MESMA camisola, com o que ela
     acrescentaria depois de esta entrar no carrinho — uma linha só, dentro da caixa do par. Os dados vêm das
     fichas de versão (gday.versoes): `data-gd2-tipo` e, quando leva o pack, `data-gd2-preco`. */
  const ADULTO = ['adepte', 'maillot', 'joueur', 'femme'];
  function familia(E, c) {
    const atual = d.querySelector('.chips-ver a[aria-current][data-gd2-tipo]');
    if (!atual || ADULTO.indexOf(atual.dataset.gd2Tipo) < 0) return '';
    const ch = d.querySelector('.chips-ver a[data-gd2-tipo="kit"][data-gd2-preco]') || d.querySelector('.chips-ver a[data-gd2-tipo="bodie"][data-gd2-preco]');
    if (!ch) return '';
    const pk = parseInt(ch.dataset.gd2Preco, 10);
    if (!(pk > 0)) return '';
    const us = E.us.concat([{ i: -1, p: c, el: true }]);
    const antes = E.R.melhor(us, E.pack).total;
    const sobeK = pk - (E.R.melhor(us.concat([{ i: -2, p: pk, el: true }]), E.pack).total - antes);
    const nome = (ch.childNodes[0] && ch.childNodes[0].textContent || '').trim();
    const href = ch.getAttribute('href') || '';
    if (!nome || !/^\//.test(href)) return '';
    return `<a class="gd2-fam" href="${esc(href)}">${T.familia.replace('%n%', esc(nome)).replace('%v%', fmt(sobeK))}</a>`;
  }
  function caixa(F) {
    let bx = d.querySelector('.gd2-duo');
    if (!bx) {
      const intro = F.querySelector('.buy-intro') || d.querySelector('.buy-intro');
      if (!intro) return null;
      bx = d.createElement('div');
      bx.className = 'gd2-duo';
      intro.insertAdjacentElement('afterend', bx);
    }
    return bx;
  }
  function ficha(E) {
    const F = d.querySelector('gd-ficha');
    const pr = d.querySelector('.pr [data-gd-price][data-cents]');
    const badge = pr && pr.parentElement.querySelector('.badge');
    const line = pr && pr.parentElement.querySelector('.packline');
    if (!F || !badge || !line) return;
    if (line.dataset.gd2Orig == null) {
      if (!/Duo|Trio/.test(line.textContent) || /\d{1,2}\/\d{1,2}/.test(line.textContent)) return;
      line.dataset.gd2Orig = line.innerHTML;
    }
    const c = parseInt(pr.dataset.cents, 10);
    const R = regras();
    const D = carrinho();
    const btn = F.btnTot, stk = F.stickTot;
    const tot = typeof F.total === 'function' ? F.total() : null;
    /* versão esgotada: a ficha deixa o botão e a barra sem preço — não se escreve lá nada */
    const disponivel = !!(F.D && F.D.disponivel);
    const bx = d.querySelector('.gd2-duo');
    if (E && E.n > 0 && c > 0 && D) {
      const v = sobe(E, c);
      if (v < c) {
        F.dataset.gd2 = '1';
        poe(pr, `${fmt(v)}<s class="gd2-s">${fmt(c)}</s>`);
        badge.hidden = true;
        line.hidden = true;
        /* com opções escolhidas (flocage, emblema…) esta camisola custa `tot`, não `c`: o botão, a barra e a caixa
           do par contam todos com ela — a 20-10 a caixa dizia 67,99 € e o carrinho cobrava 74,98 € (DE BRUYNE 7) */
        const comOpcoes = tot != null && disponivel && tot > c ? tot : c;
        const vc = comOpcoes === c ? v : sobe(E, comOpcoes);
        if (tot != null && disponivel) { const bv = sobe(E, tot); poe(btn, `· ${fmt(bv)}`); poe(stk, fmt(bv)); }
        /* o conjunto: o carrinho de agora + esta camisola */
        const orig = E.orig + comOpcoes;
        const novo = E.total + vc;
        const nome = E.n === 1 ? T.duo : (E.n === 2 ? T.trio : T.conjunto);
        const aqui = d.querySelector('.gal .slide img');
        const minha = aqui ? (aqui.currentSrc || aqui.src) : '';
        const chave = `${D.total}|${(D.linhas || []).map((l) => `${l.k}x${l.q}`).join(',')}|${c}|${novo}`;
        F.dataset.gd2Chave = chave;
        fotosCarrinho(chave.split('|').slice(0, 2).join('|')).then((lista) => {
          const b = caixa(F);
          /* só a resposta do estado ATUAL escreve (uma antiga que chegue depois é ignorada) */
          if (!b || !F.dataset.gd2 || F.dataset.gd2Chave !== chave) return;
          const imgs = lista.map((x) => `<img src="${esc(x.img)}${/\?/.test(x.img) ? '&' : '?'}width=120" alt="${esc(x.t)}" loading="lazy">`).join('<i>+</i>')
            + (minha ? `<i>+</i><img class="gd2-esta" src="${esc(minha)}" alt="">` : '');
          poe(b, `<div class="gd2-fotos">${imgs}</div><div class="gd2-txt"><b>${nome.replace('%v%', fmt(novo))}</b><span>${T.poupa.replace('%p%', fmt(orig - novo))}</span></div>${familia(E, comOpcoes)}`);
          b.hidden = false;
        });
        return;
      }
    }
    if (bx) bx.hidden = true;
    badge.hidden = false;
    if (F.dataset.gd2) {
      delete F.dataset.gd2;
      delete F.dataset.gd2Chave;
      poe(pr, fmt(c));
      if (tot != null && disponivel) { poe(btn, `· ${fmt(tot)}`); poe(stk, fmt(tot)); }
    }
    line.hidden = false;
    if (!(c > 0) || !R || !D || !D.pack) { poe(line, line.dataset.gd2Orig); return; }
    /* carrinho vazio: o que custam 2 e 3 deste artigo, pelo mesmo modelo */
    const t = (k) => k * c - R.melhor(R.unidades([{ q: k, base: c, el: true }], (l) => l.base), D.pack).total;
    poe(line, T.escada.replace('%a%', fmt(t(2))).replace('%b%', fmt(t(3))));
  }

  let pend = 0;
  function tudo() {
    cancelAnimationFrame(pend);
    pend = requestAnimationFrame(() => {
      const E = estado();
      cartoes(E);
      faixas(E);
      ficha(E);
    });
  }

  /* quando a gaveta redesenha o carrinho (gd:add → refrescar), quando a quantidade muda (gd:carrinho), quando
     aparecem cartões novos (carrosséis, filtros, pesquisa) ou quando a ficha muda de versão (data-cents) */
  d.addEventListener('gd:carrinho', tudo);
  /* com opções pagas no carrinho, as contas esperam pela tabela de preços das opções: quando chega, refaz-se */
  const ligarPrecos = () => { if (window.GdPrecos && Array.isArray(GdPrecos.ouvintes)) { GdPrecos.ouvintes.push(tudo); return true; } return false; };
  if (!ligarPrecos()) addEventListener('load', ligarPrecos, { once: true });
  let ultimo = '';
  new MutationObserver(() => {
    const el = d.querySelector('[data-gd-carrinho]');
    const txt = el ? el.textContent : '';
    const cartoesNovos = d.querySelector('.price[data-gd2]:not([data-gd2-orig])');
    if (txt !== ultimo) { if (ultimo) velho = false; ultimo = txt; tudo(); } else if (cartoesNovos) tudo();
  }).observe(d.body, { childList: true, subtree: true });
  /* a ficha reescreve o botão e a barra fixa a cada escolha (opções, versão): volta-se a pôr o nosso número */
  const F0 = d.querySelector('gd-ficha');
  if (F0) new MutationObserver(tudo).observe(F0, { attributes: true, attributeFilter: ['data-cents'], subtree: true, childList: true, characterData: true });
  /* outra aba pode ter mudado o carrinho: ao voltar a esta, confere-se com o /cart.js; se não bater com a
     fotografia desta página, deixa de se prometer até a gaveta trazer o carrinho novo */
  function conferir() {
    const D = carrinho();
    if (!D) return;
    fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((c) => { const v = c.item_count !== D.itens || c.total_price !== D.total; if (v !== velho) { velho = v; tudo(); } })
      .catch(() => {});
  }
  d.addEventListener('visibilitychange', () => { if (d.visibilityState === 'visible') conferir(); });
  addEventListener('pageshow', (e) => { if (e.persisted) conferir(); });
  /* o pack muda a uma hora marcada (edição a começar/acabar): nessa hora tira-se a promessa */
  if (LIMITE) { const ms = LIMITE * 1000 - Date.now(); if (ms > 0 && ms < 864e5) setTimeout(tudo, ms + 1000); }
  if (d.readyState === 'complete') tudo(); else addEventListener('load', tudo);
})();
